import React from "react";

const overviewOffer = [
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStoreOverview/trade.jpg"),
    name: "Trade assurance",
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStoreOverview/smooth.jpg"),
    name: "Smooth Operations",
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStoreOverview/nation.jpg"),
    name: "Nationwide Access",
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStoreOverview/support.jpg"),
    name: "Digitalize Logistics Support",
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStoreOverview/inspection.jpg"),
    name: "Product Inspection",
  }
];

const MyStoreOverview = ({ companyOverview, setCompanyOverview, selectedFeatures, setSelectedFeatures }) => {
  const handleTextareaChange = (e) => {
    setCompanyOverview(e.target.value);
  };

  const handleFeatureToggle = (featureName) => {
    setSelectedFeatures((prevSelected) =>
      prevSelected.includes(featureName)
        ? prevSelected.filter((name) => name !== featureName)
        : [...prevSelected, featureName].slice(0, 5) // Limit to 5 features
    );
  };

  return (
    <div className="w-[891px] h-[630px] rounded-b-[5px] bg-white flex flex-col items-center">
      <div className="w-[866px]">
        <h3 className="w-[141px] h-[21px] text-black font-semibold text-[14px] text-start my-[13px]">
          Company Overview
        </h3>
      </div>
      <textarea
        name="BankAddress"
        id="BankAddress"
        rows={5}
        value={companyOverview}
        onChange={handleTextareaChange}
        placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. "
        className="w-[866px] h-[135px] p-[20px] border rounded-[5px] placeholder:w-[826px] placeholder:h-[95px] placeholder:text-[12px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
      ></textarea>
      <div className="w-[866px] text-start">
        <h4 className="w-[361px] h-[21px] text-black text-start font-semibold text-[14px] mt-[22px]">
          What features do you offer ?{" "}
          <span className="font-medium text-[12px] text-black">
            ( Select up to 5 features )
          </span>
        </h4>
      </div>
      <div className="w-full h-[390px] gap-x-[24px] justify-center gap-y-[22px] flex flex-wrap mt-[13px]">
        {overviewOffer.map((item, index) => (
          <div key={index}>
            <button
              className={`w-[154px] h-[184px] rounded-[10px] bg-white border pt-[12px] pl-[11px] pr-[11px] pb-[17px] flex flex-col items-center ${
                selectedFeatures.includes(item.name) ? "border-green-500" : ""
              }`}
              onClick={() => handleFeatureToggle(item.name)}
            >
              <div className="w-full flex justify-end">
                <button
                  className={`w-[22px] h-[22px] bg-white border rounded-full ${
                    selectedFeatures.includes(item.name) ? "bg-green-500" : ""
                  }`}
                ></button>
              </div>
              <p className="w-[60px] h-[60px] bg-[#F0FFE9] rounded-full flex items-center justify-center">
                <img src={item.img} alt={item.name} />
              </p>
              <h4 className="w-full h-[30px] mt-[25px] font-semibold text-[14px] text-black flex items-center justify-center">
                {item.name}
              </h4>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyStoreOverview;
